<p-sidebar
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  position="right"
  [style]="{ width: '720px' }"
  [modal]="false"
  [showCloseIcon]="true"
  [blockScroll]="false"
  [closeOnEscape]="true"
  [appendTo]="'body'"
>
  <ng-template pTemplate="header">
    <afoone-wxrl-form-header
      [title]="drawerTitle"
      [activeTab]="'Condiciones'"
    >
    </afoone-wxrl-form-header>
  </ng-template>

  <div class="drawer-content condition-form-grid" [formGroup]="conditionForm">
    <!-- Campo ID: Editable, con valor generado automáticamente -->
    <label for="condRule" class="condition-label">ID *</label>
    <div class="condition-field">
      <input
        id="condRule"
        type="text"
        pInputText
        formControlName="condRule"
        class="w-full"
        [maxlength]="10"
        placeholder="C001, C002, etc."
      />
      <small
        class="p-error"
        *ngIf="
          conditionForm.get('condRule')?.invalid &&
          conditionForm.get('condRule')?.touched
        "
      >
        El ID es obligatorio
      </small>
    </div>

    <!-- Campo Descripción (Kommentar; opcional #697) -->
    <label for="kommentar" class="condition-label">{{
      "WXRL.SCHEMA.CONDITION_DESCRIPCION" | translate
    }}</label>
    <div class="condition-field">
      <textarea
        id="kommentar"
        pInputTextarea
        formControlName="kommentar"
        rows="3"
        class="w-full"
        [maxlength]="255"
      ></textarea>
      <small
        class="p-error"
        *ngIf="
          conditionForm.get('kommentar')?.hasError('maxlength') &&
          conditionForm.get('kommentar')?.touched
        "
      >
        {{ "WXRL.SCHEMA.CONDITION_DESCRIPCION_MAXLENGTH_ERROR" | translate }}
      </small>
    </div>

    <!-- Campo Actúa Sobre: Dropdown con carga dinámica -->
    <label for="condId" class="condition-label">Actúa Sobre *</label>
    <div class="condition-field">
      <p-dropdown
        id="condId"
        formControlName="condId"
        [options]="actuaSobreOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione un elemento"
        [showClear]="true"
        [filter]="true"
        styleClass="w-full"
        (onChange)="onActuaSobreChange()"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          conditionForm.get('condId')?.invalid &&
          conditionForm.get('condId')?.touched
        "
      >
        Este campo es obligatorio
      </small>
    </div>

    <!-- Campo Operador: Dropdown con carga dinámica según Actúa Sobre (#551: icono Info = RULESCONDITIONC.Info) -->
    <label for="rOperator" class="condition-label">Operador *</label>
    <div class="condition-field">
      <div class="flex align-items-center gap-2 condition-operator-dropdown-wrapper">
        <p-dropdown
          id="rOperator"
          formControlName="rOperator"
          [options]="dynamicOperatorOptions"
          optionLabel="labelOperator"
          optionValue="operatorKey"
          [placeholder]="'WXRL.SCHEMA.PLACEHOLDER_SELECT_OPERATOR' | translate"
          [showClear]="true"
          [filter]="true"
          scrollHeight="280px"
          styleClass="w-full condition-operator-dropdown"
          [appendTo]="'self'"
          panelStyleClass="wxrl-condition-operator-panel"
          (onChange)="onOperatorChange()"
        ></p-dropdown>
        <div class="condition-operator-info-container">
          <p-button
            type="button"
            icon="pi pi-info-circle"
            [rounded]="true"
            [text]="true"
            (click)="onOperatorInfoClick()"
            [disabled]="
              !conditionForm.get('rOperator')?.value || !selectedOperatorInfo
            "
            [pTooltip]="selectedOperatorInfo"
            [tooltipDisabled]="!selectedOperatorInfo"
            tooltipPosition="top"
            [appendTo]="'body'"
            styleClass="condition-operator-info-button"
            [attr.aria-label]="selectedOperatorInfo || null"
          ></p-button>
          <div
            *ngIf="showOperatorInfo && selectedOperatorInfo"
            class="condition-operator-info-message"
            role="status"
          >
            <div class="condition-operator-info-content">
              <span>{{ selectedOperatorInfo }}</span>
              <button
                type="button"
                class="condition-operator-info-close"
                (click)="closeOperatorInfo()"
                aria-label="Cerrar"
              >
                <i class="pi pi-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <small
        class="p-error"
        *ngIf="
          conditionForm.get('rOperator')?.invalid &&
          conditionForm.get('rOperator')?.touched
        "
      >
        El operador es obligatorio
      </small>
    </div>

    <!-- Grupo 1: EnableV1=1 - ID Elemento, Heredar, Perfil -->
    <label for="saveValue" class="condition-label" *ngIf="enableV1 && enableV1Elemento">ID Elemento *</label>
    <div class="condition-field" *ngIf="enableV1 && enableV1Elemento">
          <!-- Dropdown simple cuando multiSelectV1 es false -->
          <p-dropdown
            *ngIf="!multiSelectV1"
            id="saveValue"
            formControlName="saveValue"
            [options]="elementoOptions"
            optionLabel="label"
            optionValue="value"
            dataKey="value"
            placeholder="Seleccione un elemento"
            [showClear]="true"
            [filter]="true"
            [virtualScroll]="true"
            [virtualScrollItemSize]="38"
            [disabled]="conditionForm.get('heredar')?.value"
            styleClass="w-full"
          ></p-dropdown>
          <!-- MultiSelect cuando multiSelectV1 es true -->
          <p-multiSelect
            *ngIf="multiSelectV1"
            id="saveValueMulti"
            formControlName="saveValue"
            [options]="elementoOptions"
            optionLabel="label"
            optionValue="value"
            dataKey="value"
            placeholder="Seleccione elementos"
            [showClear]="true"
            [filter]="true"
            [virtualScroll]="true"
            [virtualScrollItemSize]="38"
            defaultLabel="Seleccione elementos"
            selectedItemsLabel="{0} elementos seleccionados"
            [disabled]="conditionForm.get('heredar')?.value"
            styleClass="w-full"
          ></p-multiSelect>
          <small
            class="p-error"
            *ngIf="
              conditionForm.get('saveValue')?.invalid &&
              conditionForm.get('saveValue')?.touched
            "
          >
            Este campo es obligatorio
          </small>
        </div>

    <!-- Checkbox Heredar (cuando hay enableV1Elemento) -->
    <span class="condition-label" *ngIf="enableV1 && enableV1Elemento"></span>
    <div class="condition-field" *ngIf="enableV1 && enableV1Elemento">
          <p-checkbox
            formControlName="heredar"
            inputId="heredar"
            [binary]="true"
          ></p-checkbox>
          <label for="heredar" class="ml-2">Heredar</label>
      </div>

      <!-- Checkbox Heredar solo (cuando no hay enableV1Elemento) -->
    <span class="condition-label" *ngIf="enableV1 && !enableV1Elemento"></span>
    <div class="condition-field" *ngIf="enableV1 && !enableV1Elemento">
        <p-checkbox
          formControlName="heredar"
        inputId="heredar-solo"
          [binary]="true"
        ></p-checkbox>
      <label for="heredar-solo" class="ml-2">Heredar</label>
      </div>

      <!-- Perfil: Dropdown dinámico -->
    <label for="grupNr" class="condition-label" *ngIf="enableV1">Perfil</label>
    <div class="condition-field" *ngIf="enableV1">
        <p-dropdown
          id="grupNr"
          formControlName="grupNr"
          [options]="perfilOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleccione un perfil"
          [showClear]="true"
          [filter]="true"
          styleClass="w-full"
        ></p-dropdown>
    </div>

    <!-- Grupo 2: EnableV2=1 - Valor de Entrada (Dropdown, MultiSelect o TextBox) — #544 -->
    <label for="entryValue" class="condition-label" *ngIf="enableV2">
      Valor de Entrada<span *ngIf="enableV2Dropdown"> *</span>
    </label>
    <div class="condition-field" *ngIf="enableV2">
      <!-- Combo simple si hay QRY2 y MultiSelectV2=0 -->
      <p-dropdown
        *ngIf="enableV2Dropdown && !multiSelectV2"
        id="entryValue"
        formControlName="entryValue"
        [options]="entryValueOptions"
        optionLabel="label"
        optionValue="value"
        dataKey="value"
        placeholder="Seleccione un valor"
        [showClear]="true"
        [filter]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        styleClass="w-full"
      ></p-dropdown>
      <!-- MultiSelect cuando hay QRY2 y MultiSelectV2=1 -->
      <p-multiSelect
        *ngIf="enableV2Dropdown && multiSelectV2"
        id="entryValueMulti"
        formControlName="entryValue"
        [options]="entryValueOptions"
        optionLabel="label"
        optionValue="value"
        dataKey="value"
        placeholder="Seleccione valores"
        [showClear]="true"
        [filter]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        defaultLabel="Seleccione valores"
        selectedItemsLabel="{0} valores seleccionados"
        styleClass="w-full"
      ></p-multiSelect>
      <!-- TextBox si no hay QRY2 (texto libre, no obligatorio) -->
      <input
        *ngIf="!enableV2Dropdown"
        id="entryValueText"
        type="text"
        pInputText
        formControlName="entryValue"
        class="w-full"
      />
      <small
        class="p-error"
        *ngIf="
          conditionForm.get('entryValue')?.invalid &&
          conditionForm.get('entryValue')?.touched &&
          enableV2 &&
          enableV2Dropdown
        "
      >
        Este campo es obligatorio
      </small>
    </div>

    <!-- Aislamiento: solo laboratorio LABM (formulario-condiciones / #479) -->
    <ng-container *ngIf="showIsolation">
      <label for="isolate" class="condition-label">Aislamiento</label>
      <p-dropdown
        id="isolate"
        formControlName="isolate"
        [options]="aislamientoOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione"
        [showClear]="true"
        styleClass="w-full condition-input"
      ></p-dropdown>
    </ng-container>

    <!-- Tipo de Resultado: Dropdown -->
    <label for="tipoRes" class="condition-label">Tipo de Resultado</label>
      <p-dropdown
        id="tipoRes"
        formControlName="tipoRes"
        [options]="tipoResOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione un tipo"
        [showClear]="true"
      styleClass="w-full condition-input"
      ></p-dropdown>

    <!-- Condición Visible: S / N / no aplica (#768) -->
    <label for="visible" class="condition-label">Condición Visible</label>
    <p-dropdown
      id="visible"
      formControlName="visible"
      [options]="visibleOptions"
      optionLabel="label"
      optionValue="value"
      styleClass="w-full condition-input"
    ></p-dropdown>

    <!-- Condición Negada: Checkbox -->
    <span class="condition-label"></span>
    <div class="condition-field">
      <p-checkbox
        formControlName="negCond"
        inputId="negCond"
        [binary]="true"
        [trueValue]="'S'"
        [falseValue]="'N'"
      ></p-checkbox>
      <label for="negCond" class="ml-2">Condición Negada</label>
    </div>

    <!-- Interrumpir evaluación si no se cumple la condición (#738) -->
    <span class="condition-label"></span>
    <div class="condition-field">
      <p-checkbox
        formControlName="exitCond"
        inputId="exitCond"
        [binary]="true"
        [trueValue]="'S'"
        [falseValue]="'N'"
      ></p-checkbox>
      <label for="exitCond" class="ml-2">Interrumpir la evaluación de la regla si no se cumple esta condición</label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="drawer-footer">
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        (click)="onCancel()"
        severity="secondary"
        [text]="true"
      ></p-button>
      <p-button
        [label]="isEditMode ? 'Actualizar' : 'Guardar'"
        icon="pi pi-check"
        (click)="onSave()"
        [disabled]="conditionForm.invalid"
      ></p-button>
    </div>
  </ng-template>
</p-sidebar>

